<template>
  <section class="plan-template-detail-wrap"> 
    <div class="ptdheader">
      <div class="cover" :style="{ backgroundImage: `url(https://donotplan-app-1336093681.cos.ap-shanghai.myqcloud.com/${data?.userInfo?.avatar})` }" />
      <span>{{ data?.userInfo?.nickname }}</span>
    </div>
    <div class="ptdbanners">
      <div class="banner" v-if="data?.images && data?.images.length > 0" :style="{ backgroundImage: `url(https://donotplan-app-1336093681.cos.ap-shanghai.myqcloud.com/${data?.images[0]?.url})` }" />
      <div class="txtbanner" v-else>
        <div class="bg" :style="{ backgroundColor: data?.bgColor }" />
        <span :style="{ color: data?.bgColor }">{{ data?.title }}</span>
      </div>
    </div>
    <div class="ptdcontent">
      <div class="title">{{data?.title}}</div>
      <div class="desc" v-html="data?.content.replace(/\n/g, '<br />')" v-if="data?.content" />
      <div class="tags" v-if="data?.planCategoryList && data?.planCategoryList.length > 0">
        <span v-for="(item, index) in data?.planCategoryList" :key="index">#{{ item?.name }}</span>
      </div>
      <div class="deploytime">发布于 {{ data?.createdAt && moment(data?.createdAt).format('YYYY-MM-DD') || '-' }}</div>
    </div>
    <div class="tasks" v-if="data?.tasks && data?.tasks.length > 0">
      <div class="title">计划清单</div>
      <div class="tasklist">

        <div class="item" v-for="(item, index) in data?.tasks" :key="index">
          <!-- <div class="date">第1天</div> -->
          <div class="item-content">
            <div class="item-content-item">
              <span class="name">{{item?.title}}</span>
              <span class="desc" v-html="item?.remark && item?.remark.replace(/\n/g, '<br />') || ''" />
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="downloadbtn" @click="openChongyiDownload"><span>打开 宠一APP</span></div>
  </section>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import * as Request from '@/assets/request.js';
  import { openChongyiDownload } from '@/assets/utils.js';
  import moment from 'moment';

  // 获取网址参数
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('id')

  const data = ref(null)

  const getData = async () => {
    const result = await Request.post({
      url: `/aideas/project/detail`,
      data: {
        id: id,
      }
    })
    data.value = result.data
  }

  onMounted(() => {
    getData()
  })

</script>

<style scoped lang="less">
@import "index.less";
</style>
